// extracted by mini-css-extract-plugin
module.exports = {"mainApp":"_2TlaEFMTnI4U-RzialwtLb","logo":"_2PxnXtEvKWLwI9XlyBxv-G","trigger":"_1rglkT9KdHHvsV-Fh-NWCG","layoutBackground":"_1V8PMtVOb784zEPSXlwZ8S"};